// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__wEF1q","title":"BackImages_title__3Eina","images":"BackImages_images__3Wuuk"};